"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VmetaResponseStatus = void 0;
var VmetaResponseStatus;
(function (VmetaResponseStatus) {
    VmetaResponseStatus["Success"] = "success";
    VmetaResponseStatus["Error"] = "error";
})(VmetaResponseStatus || (exports.VmetaResponseStatus = VmetaResponseStatus = {}));
